/*
 *
 * TransactionDetailsNotePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 06-Jun-2025
*/
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import TransactionDetailsNotePopup from './TransactionDetailsNotePopup'
import { doHidePopup } from 'Store/actions/popup'
import * as TransactionsActions from '../../routes/Transactions/modules/TransactionsActions'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TransactionsActions, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  authorizedTransactionDetailsNote: nullSafe(() => state.Transactions.authorizedTransactionDetailsNote, {}),
  transactionContext: nullSafe(() => state.popup.popupInfo.transactionDetails, {}),
  isLoading: nullSafe(() => state.loading.localLoading.edit_authorized_transaction_details_note, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TransactionDetailsNotePopup)
